import { render, staticRenderFns } from "./packingWork.vue?vue&type=template&id=3df47926&scoped=true"
import script from "./packingWork.vue?vue&type=script&lang=js"
export * from "./packingWork.vue?vue&type=script&lang=js"
import style0 from "./packingWork.vue?vue&type=style&index=0&id=3df47926&prod&lang=less&scoped=true"
import style1 from "./packingWork.vue?vue&type=style&index=1&id=3df47926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df47926",
  null
  
)

export default component.exports